/**
 * Detects large JSON/tool payloads from restored `tool_result` user turns.
 * These are shown in a compact, scrollable block so the panel layout and page scroll stay stable.
 */
export function isRestoredTechnicalUserContent(content: string): boolean {
  const t = content.trim()
  if (t.length >= 2000) return true
  if (
    t.length >= 400 &&
    (t.startsWith('{') || t.startsWith('[')) &&
    /[\]{}]/.test(t)
  ) {
    return true
  }
  return false
}
